function importAll(r) {
    let pics = {};
    r.keys().forEach((item) => {
      pics[item.replace('./', '')] = r(item);
    });
    return pics;
  }
  
  export const images = importAll(require.context('./Images/gallery', false, /\.(jpg)$/));
  